import { createSlice } from '@reduxjs/toolkit';
import { PERIOD_OPTION_MONTH } from "utils/periodOptions";

const currentMonth = new Date().getMonth();
const reportSlice = createSlice({
  name: 'report',
  initialState: {
    rows: [],
    summaryRows: [],
    hours: {
      expected: 0,
      total: 0,
      overtime: 0
    },
    filter: {
        client: null,
        member: null,
        year: new Date().getFullYear(),
        summaryYear: new Date().getFullYear(),
        searchOption: PERIOD_OPTION_MONTH,
        month: currentMonth,
        summaryMonth: currentMonth,
        week: 1,
        startDate: new Date(),
        endDate: new Date()
    }
  },
  reducers: {
    replaceData(state, action) {
      state.rows = action.payload;
    },
    replaceSummaryRows(state, action) {
      state.summaryRows = action.payload;
    },
    replaceClient(state, action) {
      state.filter.client = action.payload
    },
    replaceMember(state, action) {
      state.filter.member = action.payload
    },
    replaceYear(state, action) {
      state.filter.year = action.payload
    },
    replaceSummaryYear(state, action) {
      state.filter.summaryYear = action.payload
    },
    replaceSearchOption(state, action) {
      state.filter.searchOption = action.payload
    },
    replaceStartDate(state, action) {
      state.filter.startDate = action.payload
    },
    replaceEndDate(state, action) {
      state.filter.endDate = action.payload
    },
    replaceMonth(state, action) {
      state.filter.month = action.payload
    },
    replaceSummaryMonth(state, action) {
      state.filter.summaryMonth = action.payload
    },
    replaceWeek(state, action) {
      state.filter.week = action.payload
    },
    replaceExpectedHours(state, action) {
      state.hours.expected = action.payload
    },
    replaceTotalHours(state, action) {
      state.hours.total = action.payload
    },
    replaceOvertimeHours(state, action) {
      state.hours.overtime = action.payload
    },
  },
});

export const reportActions = reportSlice.actions;

export default reportSlice;